import Head from "next/head";
import React from "react";

import QuickVideosMain from "@/components/quick-videos/quick-videos-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function QuickVideos() {
  return (
    <>
      <Head>
        <title>{seoData.QUICK_VIDEOS.title}</title>
        <SeoMetaData data={seoData.QUICK_VIDEOS} />
      </Head>

      <QuickVideosMain showTitle />
    </>
  );
}
